module.exports = __webpack_public_path__ + "img/video-editor.f54911f1.svg";